import { useEffect, useLayoutEffect, useRef } from 'react';

// Multiple public-page fetches share the barrier. Layout effects register before
// passive effects signal readiness, after React has committed the visible DOM.
export default function usePrerenderReady(loading) {
  const token = useRef(Symbol('public-content'));
  useLayoutEffect(() => {
    const state = window.__kalamanchPrerender;
    if (!state || state.expired) return undefined;
    const key = token.current;
    if (loading) {
      state.pending.add(key);
      window.prerenderReady = false;
    } else {
      state.pending.delete(key);
    }
    return () => state.pending.delete(key);
  }, [loading]);

  useEffect(() => {
    const state = window.__kalamanchPrerender;
    if (!state || state.expired) return undefined;
    const frame = requestAnimationFrame(() => {
      if (!state.pending.size) window.prerenderReady = true;
    });
    return () => cancelAnimationFrame(frame);
  }, [loading]);
}
